<template>
  <div>
    <div class="fixed inset-0 overflow-y-auto" :style="{ zIndex: 10001 }">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
        >&#8203;

        <div
          class="inline-block align-bottom rounded bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div
            class="bg-white px-4 py-4 relative"
            style="max-width: 500px; width: 500px; min-width: 320px"
          >
            <div class="absolute" style="top: 10px; right: 15px">
              <button @click="$emit('close-modal')">
                <i class="fas fa-times fa-lg text-red-500"></i>
              </button>
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Modal",
  props: {},
};
</script>
